import type { FaireProductEntity } from "../../entity_types/product";

export const p_yekgpnugnw: FaireProductEntity = {
  token: "p_yekgpnugnw",
  type: "product",
  name: "Copper Spheres 30mm",
  brandToken: "b_eqykpyrhjx",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/b5f4ba50bacba99956eda6847601c9ed4420bbf65d1366bcbcd0e505de5ef9ef.jpeg",
  galleryImageUrls: [],
  priceDollars: 18.5,
  description: "You will receive 1 copper sphere 30mm\n\nAs a conductor of energy, when used with earthly crystals it intensifies, enhances and channels their properties. Copper is thought to assist the body with repairing tissues, oxygenating the blood, easing arthritis, strengthening the female reproductive system and increasing vitality.\n\n*Crystals comes from Mother Earth, there will be slight variations for each stone, color, size, shape, etc. All metaphysical information given by The Healing Sanctuary is for spiritual purposes only.\n\n*Each and every crystal shipped from us is blessed with Reiki Love.\n\n\n\n",
  tags: [],
  msrpDollars: 37,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:57.420Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
